import React, { useState, useContext, useEffect } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";
import "../styles/toolkit.css";

const ToolKit = () => {
  return (
    <>
      <Container fluid id="toolkit">
        <Container>
          <Row>
            <Col xs={12}>
              <h2>Career Toolkit</h2>
              <p>Start Your Journey to Success</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={4}>
              <h3>Get Personalized Support</h3>
              <ul>
                <li><Link to="/career-toolkit/personalized-support/advising-appointments/">Career Advising Appointments ➝</Link></li>
                <li><Link to="/career-toolkit/personalized-support/practice-interview-program/">Practice Interview Program ➝</Link></li>
              </ul>
              
              <h3>Explore Career Paths</h3>
              <ul>
               
                <li><Link to="/career-toolkit/get-career-ready/resume-and-interview-toolkit/">Resume & Interview Toolkit ➝</Link></li>
                <li><Link to="/career-toolkit/get-career-ready/grad-school-toolkit/">Grad School Toolkit ➝</Link></li>
              </ul>

              <h3>Find Opportunities</h3>
              <ul>
                <li><Link to="/career-toolkit/find-opportunities/uchicago-handshake/">UChicago Handshake ➝</Link></li>
                <li><Link to="/career-toolkit/discover-your-passion/industry-newsletters/">Career Newsletters ➝</Link></li>
              </ul>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <h3>Explore Career Paths</h3>
              <ul>
                <li><Link to="/career-toolkit/discover-your-passion/career-exploration/">Career Exploration ➝</Link></li>
                <li><Link to="/career-toolkit/discover-your-passion/industry-guides/">Industry Guides ➝</Link></li>
              </ul>
              <h3>Grow Your Network</h3>
              <ul>
                <li><Link to="/career-toolkit/grow-your-network/networking-101/">Networking 101 ➝</Link></li>
                <li><Link to="/career-toolkit/grow-your-network/alumni-directory/">Alumni Directory ➝</Link></li>
              </ul>
            </Col>

            <Col xs={12} sm={6} md={5}>
              <img src="https://images.ctfassets.net/xrhc6s36njjr/6gvJG0YlnhQR0zuy6FAVMv/faad7d3bb83d5381af97d7e380e0c952/students.webp" alt="Career Toolkit" />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default ToolKit;
